import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { axInst } from "../Login/Service";

const fetchRetailPPlModal = async (body, endpoint) => {
  try {
    const res = await axInst.post(endpoint, body);
    return res.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

const RetailpplModal = ({ closeModal, modalData }) => {
  // const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const { data, submitted } = useSelector((e) => e.filtersPipeline);

  const apiPayload = {
    ...data,
    ...modalData.selOps,
    lob: modalData.lob,
  };

  const {
    data: RetailPplData = {},
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["RetailPpl", submitted, modalData],
    queryFn: () => fetchRetailPPlModal(apiPayload, modalData.api),
  });

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  const entries = Object.entries(RetailPplData);

  return (
    <div className="absolute inset-0 flex items-center justify-center ">
      <div className="bg-white p-2 rounded-lg shadow-xl border border-gray-200 w-[220px]">
        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <div className={`${modalData.darkcolor} rounded-full p-2`}>
            <img src={modalData.icon} alt={modalData.alt} className="w-6" />
          </div>

          <h2 className="text-sm font-semibold">{modalData.clickedLabel}</h2>

          <button onClick={closeModal} className="text-gray-600 text-xl">
            &times;
          </button>
        </div>

        {/* Data */}
        {!isFetching && entries.length > 0 && (
          <ul>
            {entries.map(([key, value]) => (
              <li
                key={key}
                className="flex justify-between p-1 text-xs bg-gray-50 border-b border-gray-800 rounded-md hover:bg-gray-100"
              >
                <span>{key}</span>
                <span
                  className={`${modalData.darkcolor} text-white px-2 rounded`}
                >
                  {value}
                </span>
              </li>
            ))}
          </ul>
        )}

        {isFetching && <p className="text-center text-gray-500">Loading...</p>}
        {isError && <p className="text-center text-red-500">Failed to load</p>}
      </div>
    </div>
  );
};

export default RetailpplModal;
